import { Component, h, Prop } from '@stencil/core';
import AuthHeader from '../auth-header';

@Component({
  tag: 'hd-email-verification',
  shadow: false,
})
export class HdEmailVerification {
  @Prop() email: string;

  render() {
    return (
      <div class="confirmation-container step-container">
        <AuthHeader
          title="Please verify your email to continue"
          subhead={`We’ve sent a confirmation email to ${this.email || "your email address"}.<br>Please check your inbox and click the link to activate your account and finish the process.`}
        />
        <video class="email-verification-video" muted autoplay loop playsInline style={{ height: "200px" }}>
          <source src="https://assets.adsttc.com/piano/videos/illustration-thanks-envelope.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }
}
